import { render, staticRenderFns } from "./LinkRequestsQueue.vue?vue&type=template&id=0d9e1852&scoped=true"
import script from "./LinkRequestsQueue.vue?vue&type=script&lang=js"
export * from "./LinkRequestsQueue.vue?vue&type=script&lang=js"
import style0 from "./LinkRequestsQueue.vue?vue&type=style&index=0&id=0d9e1852&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9e1852",
  null
  
)

export default component.exports